document.addEventListener('DOMContentLoaded', () => {
  const miniCartItems = document.querySelector('.mini-cart__items');

  const placeholderSvg = `
    <svg width="100%" height="100%" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="No image">
      <rect width="200" height="200" fill="#f3f3f3"/>
      <text x="50%" y="50%" text-anchor="middle" dy=".3em" font-size="28" fill="#ccc">No Image</text>
    </svg>
  `;

  // --- Helper: получить line item key по variant id, если data-key нет в кнопке ---
  async function getLineKeyFromVariantId(variantId) {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const found = cart.items.find(i => String(i.variant_id) === String(variantId) || String(i.id) === String(variantId));
      return found ? found.key : null;
    } catch (e) {
      console.error('getLineKeyFromVariantId error', e);
      return null;
    }
  }


  // --- Обновляем секции Dawn (bubble и drawer) ---
  async function refreshDawnSections(cartDataFromCaller = null) {
    try {
      const cart = cartDataFromCaller || await fetch('/cart.js').then(r => r.json());
      const response = await fetch('/cart?sections=cart-drawer,cart-icon-bubble');
      const sections = await response.json();

      // --- Обновляем cart-icon-bubble ---
      const bubbleWrapper = document.querySelector('#cart-icon-bubble');
      if (bubbleWrapper && sections['cart-icon-bubble']) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sections['cart-icon-bubble'];
        const newBubble = tempDiv.querySelector('#cart-icon-bubble');
        if (newBubble) bubbleWrapper.replaceWith(newBubble);
      }

      // --- Обновляем cart-drawer ---
      const cartDrawer = document.querySelector('cart-drawer');
      const wasOpen = !!(cartDrawer && (cartDrawer.classList.contains('active') || cartDrawer.classList.contains('is-open')));
      if (sections['cart-drawer']) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sections['cart-drawer'];
        const newDrawer = tempDiv.querySelector('cart-drawer');

        if (cartDrawer && newDrawer) {
          cartDrawer.replaceWith(newDrawer);
        } else if (!cartDrawer && newDrawer) {
          document.body.appendChild(newDrawer);
        }

      requestAnimationFrame(() => {
        const restoredDrawer = document.querySelector('cart-drawer');
        if (!restoredDrawer) return;

        const hasNonSampleItems = cart.items.some(item => !String(item.product_title || '').toLowerCase().includes('sample'));
        const hasSampleItems = cart.items.some(item => String(item.product_title || '').toLowerCase().includes('sample'));
        const isEmpty = !(hasNonSampleItems || hasSampleItems);

        // --- Обновляем классы, но не открываем дравер ---
        restoredDrawer.classList.toggle('is-empty', isEmpty);
        restoredDrawer.classList.remove('active'); // удаляем active, чтобы дравер не открывался
        document.body.classList.remove('overflow-hidden'); // убираем блокировку скролла
      });



      }

      // перепривязываем обработчики после обновления DOM
      bindCartRemoveButtons();
      bindMiniToDrawerSync();
      bindDrawerToMiniSync();
    } catch (err) {
      console.error('Error refreshing Dawn sections:', err);
    }
  }


  // --- Обновление миникорзины ---
  async function updateMiniCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const sampleItems = cart.items.filter(item =>
        String(item.product_title || '').toLowerCase().includes('sample')
      );

      miniCartItems.innerHTML = '';
      if (sampleItems.length === 0) {
        //miniCartItems.innerHTML = '<p>No samples yet.</p>';
      } else {
        sampleItems.forEach(item => {
          const div = document.createElement('div');
          div.classList.add('mini-cart__item');

          const imageHTML = item.image
            ? `<img src="${item.image}" alt="${item.title}">`
            : placeholderSvg;

          // добавляем data-key и data-variant-id, чтобы синхронизация работала корректно
          div.innerHTML = `
            <div class="mini-cart__info">${imageHTML}</div>
            <button class="mini-cart__remove" data-key="${item.key}" data-variant-id="${item.variant_id}" aria-label="Remove sample">×</button>
          `;
          miniCartItems.appendChild(div);
        });
      }

      // --- Удаление семплов из миникорзины ---
      miniCartItems.innerHTML = '';
      const addedKeys = new Set(); // отслеживаем уже добавленные

      sampleItems.forEach(item => {
        if (addedKeys.has(item.key)) return; // пропускаем дубликаты
        addedKeys.add(item.key);

        const div = document.createElement('div');
        div.classList.add('mini-cart__item');

        const imageHTML = item.image
          ? `<img src="${item.image}" alt="${item.title}">`
          : placeholderSvg;

        div.innerHTML = `
          <div class="mini-cart__info">${imageHTML}</div>
          <button class="mini-cart__remove" aria-label="Remove sample">×</button>
        `;

        const removeBtn = div.querySelector('.mini-cart__remove');

        // навешиваем обработчик удаления
        const lineKey = item.key;
        const variantId = item.variant_id;

        removeBtn.addEventListener('click', async () => {
          try {
            let keyToUse = lineKey;
            if (!keyToUse && variantId) {
              keyToUse = await getLineKeyFromVariantId(variantId);
            }
            if (!keyToUse) {
              console.warn('No line item key found for mini remove button');
              return;
            }

            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: keyToUse, quantity: 0 })
            });

            const freshCart = await fetch('/cart.js').then(r => r.json());
            await updateMiniCart();
            await refreshDawnSections(freshCart);
          } catch (err) {
            console.error('Error removing sample:', err);
          }
        });

        miniCartItems.appendChild(div);
      });



      // --- Дизейбл кнопок добавления ---
      const sampleIds = sampleItems.map(i => i.id);
      /*document.querySelectorAll('.add-sample-btn, .add-sample-pdp').forEach(btn => {
        const btnId = parseInt(btn.dataset.sampleProductId);
        if (sampleIds.includes(btnId)) {
          btn.disabled = true;
          btn.textContent = 'Sample in cart';
        } else {
          btn.disabled = false;
          btn.textContent = 'Add sample';
        }
      });*/
      document.querySelectorAll('.add-sample-btn, .add-sample-pdp').forEach(btn => {
        const btnId = parseInt(btn.dataset.sampleProductId, 10);
        let span = btn.querySelector('span');

        // если span отсутствует — создаём
        if (!span) {
          span = document.createElement('span');
          span.textContent = btn.textContent.trim();
          btn.textContent = '';
          btn.appendChild(span);
        }

        if (sampleIds.includes(btnId)) {
          btn.disabled = true;
          span.textContent = 'Sample in cart';
        } else {
          btn.disabled = false;
          span.textContent = 'Add sample';
        }
      });


      // после перерендера миникарзины перепривяжем синхронизацию
      bindMiniToDrawerSync();
    } catch (err) {
      console.error('Error updating mini-cart:', err);
    }

    syncMiniCartHeader();
    updateMiniCartItemsWidth();
  }


  function updateMiniCartItemsWidth() {
    const miniCart = document.getElementById('mini-cart');
    const itemsWrap = miniCart.querySelector('.mini-cart__items');

    if (!itemsWrap) return;

    const sampleItems = itemsWrap.querySelectorAll('.mini-cart__item');
    const sampleCount = sampleItems.length;
    const isMobile = window.innerWidth <= 767;

    // учитываем паддинги родителя
    const parentPadding = 10 * 2; // 10px слева + 10px справа
    const parentWidth = itemsWrap.offsetWidth - parentPadding;

    if (isMobile) {
      // ===== МОБ =====
      itemsWrap.classList.remove('min-w515'); // класс на моб не нужен

      if (sampleCount >= 1 && sampleCount <= 5) {
        const itemWidth = Math.floor(parentWidth / 5); // 5 элементов в ряд
        sampleItems.forEach(item => {
          item.style.width = `${itemWidth}px`;
          item.style.height = `${itemWidth}px`;
          item.style.paddingBottom = `${itemWidth}px`; // если используется для пропорций
        });
      } else {
        sampleItems.forEach(item => {
          item.style.width = '';
          item.style.height = '';
          item.style.paddingBottom = '';
        });
      }
    } else {
      // ===== DESKTOP =====
      const itemWidth = Math.floor(parentWidth / 5); // 5 элементов в ряд
      sampleItems.forEach(item => {
        item.style.width = `${itemWidth}px`;
        item.style.height = `${itemWidth}px`;
        item.style.paddingBottom = `${itemWidth}px`;
      });
    }
  }


  // --- запуск при ресайзе и загрузке ---
  window.addEventListener('resize', updateMiniCartItemsWidth);
  window.addEventListener('load', updateMiniCartItemsWidth);

  function syncMiniCartHeader() {
      const miniCart = document.getElementById('mini-cart');
      const title = miniCart.querySelector('h4');
      const itemsWrap = miniCart.querySelector('.mini-cart__items');

      const hasSamples = itemsWrap.querySelectorAll('.mini-cart__item').length > 0;

      if (hasSamples) {
        // если семплы есть → h4 скрыт
        title.classList.remove('active');
      }
      // если семплов нет — оставляем текущее состояние h4 (toggle при клике)
  }
  

  // --- Добавление sample ---
  async function addSampleHandler(button) {
  const id = button.dataset.sampleProductId;
  if (!id) return alert('Sample product is not set.');

  // --- Дизейблим все кнопки ---
  const allSampleBtns = document.querySelectorAll('.add-sample-btn, .add-sample-pdp');
  allSampleBtns.forEach(btn => {
    btn.disabled = true;
    const span = btn.querySelector('span') || btn;
    span.textContent = 'Adding...';
  });

  try {
    // --- Добавляем sample ---
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 })
    });

    if (!res.ok) throw new Error(await res.text());
    const addedItem = await res.json(); // данные о добавленном семпле

    // --- Получаем свежую корзину ---
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    // --- Обновляем миникорзину ---
    await updateMiniCart();
    
    // --- Обновляем секции Dawn (Drawer и Bubble) ---
    await refreshDawnSections(cart);

    // --- Обновляем cart-count-bubble вручную ---
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    const cartItemCount = cart.item_count;
    if (bubble) {
      bubble.textContent = cartItemCount;
      const visuallyHidden = bubble.parentElement.querySelector('.visually-hidden');
      if (visuallyHidden) visuallyHidden.textContent = `${cartItemCount} item${cartItemCount > 1 ? 's' : ''}`;
    } else {
      const icon = document.querySelector('#cart-icon-bubble');
      if (icon) {
        const div = document.createElement('div');
        div.classList.add('cart-count-bubble');
        div.innerHTML = `<span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden">${cartItemCount} item${cartItemCount > 1 ? 's' : ''}</span>`;
        icon.appendChild(div);
      }
    }

    // --- Обновляем текст и disabled кнопок ---
    allSampleBtns.forEach(btn => {
      const btnId = parseInt(btn.dataset.sampleProductId, 10);
      const span = btn.querySelector('span') || btn;

      if (cart.items.find(i => i.id === btnId)) {
        btn.disabled = true;
        span.textContent = 'Sample in cart';
      } else {
        btn.disabled = false;
        span.textContent = 'Add sample';
      }
    });

    // --- Показываем миникорзину, если есть функция ---
    if (typeof showMiniCart === 'function') showMiniCart();

  } catch (err) {
    console.error('Error adding sample:', err);
    alert('Error adding sample to cart.');

    // --- Включаем кнопки обратно при ошибке ---
    allSampleBtns.forEach(btn => {
      const span = btn.querySelector('span') || btn;
      btn.disabled = false;
      span.textContent = 'Add sample';
    });
  }
}



  // --- Привязка кнопок добавления ---
  function bindSampleButtons() {
    document.querySelectorAll('.add-sample-btn, .add-sample-pdp').forEach(btn => {
      if (!btn.dataset.bound) {
        btn.dataset.bound = true;
        btn.addEventListener('click', e => {
          e.preventDefault();
          addSampleHandler(btn);
        });
      }
    });
  }


  // --- Привязка кнопок удаления в основной корзине для синхронизации с миникорзиной ---
  function bindCartRemoveButtons() {
    document.querySelectorAll('cart-remove-button button').forEach(btn => {
      if (!btn.dataset.bound) {
        btn.dataset.bound = true;
        btn.addEventListener('click', async (e) => {
          // Прекращаем всплытие — чтобы избежать двойных кликов, если мы инициируем клик из миникорзины
          // но осторожно: если другие скрипты полагаются на всплытие - можно убрать e.stopPropagation()
          // e.stopPropagation();

          // пытаемся взять lineKey напрямую
          let lineKey = btn.dataset.key || btn.dataset.lineKey || btn.dataset['key'];
          const variantId = btn.dataset.variantId || btn.dataset.variant_id;

          if (!lineKey && variantId) {
            lineKey = await getLineKeyFromVariantId(variantId);
          }

          if (!lineKey) {
            console.warn('Missing data-key on remove button and cannot resolve from variant id');
            return;
          }

          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: lineKey, quantity: 0 })
            });

            const freshCart = await fetch('/cart.js').then(r => r.json());
            await updateMiniCart();
            await refreshDawnSections(freshCart);
          } catch (err) {
            console.error('Error removing item from cart:', err);
          }
        });
      }
    });

    // После привязки — синхронизируем cross-click handlers
    bindDrawerToMiniSync();
  }


  // --- Синхронизация: клик в мини → клик в drawer (если есть кнопка drawer) ---
  function bindMiniToDrawerSync() {
    document.querySelectorAll('.mini-cart__remove').forEach(remove_btn => {
      if (!remove_btn.dataset.syncBound) {
        remove_btn.dataset.syncBound = true;
        remove_btn.addEventListener('click', function () {
          const data_variant = this.getAttribute('data-id') || this.dataset.variantId || this.dataset.variant_id;
          const drawerBtn = document.querySelector(`button[data-variant-id="${data_variant}"]`) || document.querySelector(`button[data-variant-id='${data_variant}']`);
          if (drawerBtn) drawerBtn.click();
        });
      }
    });
  }


  // --- Синхронизация: клик в drawer → клик в мини ---
  function bindDrawerToMiniSync() {
    document.querySelectorAll('#CartDrawer-CartItems cart-remove-button button[data-variant-id]').forEach(remove_btn => {
      if (!remove_btn.dataset.syncBound) {
        remove_btn.dataset.syncBound = true;
        remove_btn.addEventListener('click', function () {
          const variant_id = this.getAttribute('data-variant-id') || this.dataset.variantId || this.dataset.variant_id;
          const miniBtn = document.querySelector(`.mini-cart__item button[data-id="${variant_id}"]`);
          if (miniBtn) miniBtn.click();
        });
      }
    });
  }

  
  // --- INIT ---
  updateMiniCart();
  bindSampleButtons();
  bindCartRemoveButtons();
  bindMiniToDrawerSync();
  bindDrawerToMiniSync();

  // --- Для динамических карточек ---
  const observer = new MutationObserver(() => {
    bindSampleButtons();
    bindCartRemoveButtons();
    bindMiniToDrawerSync();
    bindDrawerToMiniSync();
    // обновляем мини-карту периодически если контейнер появился позже
    // (не вызываем updateMiniCart чтобы не нагружать, только при необходимости можно раскомментировать)
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
